import { createTheme as e } from "../../_mixins/use-theme.js";
import m from "../../_styles/common/light.js";
import n from "../../_internal/select-menu/styles/light.js";
import r from "../../input/styles/light.js";
function i(t) {
  const {
    boxShadow2: o
  } = t;
  return {
    menuBoxShadow: o
  };
}
const p = e({
  name: "AutoComplete",
  common: m,
  peers: {
    InternalSelectMenu: n,
    Input: r
  },
  self: i
}), h = p;
export {
  h as default,
  i as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/auto-complete/styles/light.js
// module id = 1591
// module chunks = 41